const IMAGE_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/webp',
]);

export function classifyAttachmentFile(file) {
  const filename = String(file?.name || '');
  const contentType = String(file?.type || '').toLowerCase();
  if ((IMAGE_MIME_TYPES.has(contentType) || contentType === '') && /\.(jpe?g|png|svg|webp)$/i.test(filename)) {
    return 'image';
  }
  if (/\.md$/i.test(filename) && ['text/markdown', 'text/plain', 'application/octet-stream', ''].includes(contentType)) {
    return 'markdown';
  }
  if (/\.pdf$/i.test(filename) && ['application/pdf', 'application/octet-stream', ''].includes(contentType)) {
    return 'pdf';
  }
  return null;
}

export function attachmentFilesFromTransfer(dataTransfer) {
  return Array.from(dataTransfer?.files || [])
    .map((file) => ({ file, kind: classifyAttachmentFile(file) }))
    .filter((entry) => entry.kind);
}

export function attachmentDropParentId({ targetNodeId, selectedNodeId, rootNodeId }) {
  return targetNodeId || selectedNodeId || rootNodeId || null;
}
